module.exports = __webpack_public_path__ + "img/img17.939065a2.svg";